import { AjaxActions } from '@tock/shared/utils/AjaxActions';

let ajaxActions: AjaxActions | undefined = undefined;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createApiClient(options: any) {
  if (!ajaxActions) {
    ajaxActions = new AjaxActions(options);
    return ajaxActions;
  }

  return ajaxActions;
}

export function getApiClient() {
  if (!ajaxActions) {
    throw new Error('an api client was not created yet');
  }

  return ajaxActions;
}
